/** Specifies the keyboard modifier keys. */
export type ModifierKey = "alt" | "shift" | "ctrl" | "meta";

/** The modifier keys. */
export const ModifierKeys: readonly ModifierKey[] = ["alt", "shift", "ctrl", "meta"];
